export const FILTER_IS_LOADING = 'FILTER_IS_LOADING';